/**
 * @author xiaohuangmaoth
 * @description 线下培训学员统计
 * @Date 2021/03/02
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool } from "@/tool";
import { templateConfig, reduxTemplateCofig } from "./config";
import column from './column';

const { WizContainer, WizReduxTemplate } = framework_tool;
const { WizBrowserExport } = component_tool

class StatisticsOfflineTrainees extends WizContainer {
  componentName = "StatisticsOfflineTrainees";

  handleFile(nextProps, nextState, key) {
    const res = nextProps[key]
    const { success, data = [], msg } = res

    if (success) {
      const rows = data.map(val => ({
        ...val,
        accountState: val.accountState ? '激活' :'禁用',
        jobState: val.jobState ? '在职' :'离职',
        pass: val.pass!=null && val.pass===1 ? '通过' : val.pass!=null && val.pass===2 ?
          '未通过':val.pass!=null && val.pass===3 ? '无成绩' : '未输入',
      }))
      const title = '线下培训学员统计'
      WizBrowserExport({
        title,
        sheetName: title,
        columns: column.filter((_, index) => index),
        rows,
        filename: title + '.xlsx',
      })
      return true

    } else {
      wizNotice.error(msg)
      return false;
    }

  }

  _render() {
    const _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig: templateConfig.call(this),
      apiDataFormat: {
        export: this.handleFile
      },
    });

    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

export default connect(() => ({}))(StatisticsOfflineTrainees);
